<template>
    <div class="inquiry-table">

        <div class="m-content">
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Anfragen
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="m-portlet__body">

                    <form class="m-form">
                        <div class="row mb-4">
                            <div class="col-12 col-md-5">
                                <div class="m-form__group form-group">
                                    <label><b>Status</b></label>
                                    <div class="m-checkbox-inline">
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="status1" v-model="status1" @click="loadData()"> Neu
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="wait" v-model="wait" @click="loadData()"> Wait
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="status2" v-model="status2" @click="loadData()"> Anfrage gesendet
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="status3" v-model="status3" @click="loadData()"> Kunde angelegt
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="reminder" v-model="reminder" @click="loadData()"> Reminder
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="noreminder" v-model="noreminder" @click="loadData()"> Nur keine Notizen
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="packageOnWay" v-model="packageOnWay" @click="loadData()"> Nur Pakete Unterwegs
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-5">
                                <div class="m-form__group form-group">
                                    <label><b>Kundengruppen</b></label>
                                    <div class="m-checkbox-inline">
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="showAClient" v-model="showAClient" @click="loadData()"> A Kunde
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="showBClient" v-model="showBClient" @click="loadData()"> B Kunde
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="showCClient" v-model="showCClient" @click="loadData()"> C Kunde
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="showDClient" v-model="showDClient" @click="loadData()"> D Kunde
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="showEClient" v-model="showEClient" @click="loadData()"> E Kunde
                                            <span></span>
                                        </label>
                                        <label class="m-checkbox">
                                            <input type="checkbox" name="showFClient" v-model="showFClient" @click="loadData()"> F Kunde
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-md-2">
                                <a href="#" data-modal="add-anfrage-modal" class="btn btn-primary m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill">
                                    <span>
                                        <i class="la la-cart-plus"></i>
                                        <span>Anfrage anlegen</span>
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <div class="col-12 col-md-5">
                                <div class="m-form__group form-group">
                                    <label><b>Anfragentyp</b></label>
                                    <div class="m-checkbox-inline">
                                        <label class="m-radio">
                                            <input name="inquiryType" type="radio" value="0" v-model="inquiryType" @click="loadData()"> Alle
                                            <span></span>
                                        </label>
                                        <label class="m-radio">
                                            <input name="inquiryType" type="radio" value="1" v-model="inquiryType" @click="loadData()"> Produktfotografie Formular
                                            <span></span>
                                        </label>
                                        <label class="m-radio">
                                            <input name="inquiryType" type="radio" value="2" v-model="inquiryType" @click="loadData()"> Clipping-Agency Formular
                                            <span></span>
                                        </label>
                                        <label class="m-radio">
                                            <input name="inquiryType" type="radio" value="3" v-model="inquiryType" @click="loadData()"> Neukundenakquise
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-5">
                                <div class="m-form__group form-group">
                                    <label><b>Suche</b></label>
                                    <div>
                                        <input class="form-control m-input" type="text" autocomplete="off" name="searchString" v-model="searchString"  @keydown="loadData()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="m-section__content">
                        <table class="table table-striped- table-bordered table-hover table-checkable" id="inquiry-table">
                            <thead>
                                <tr role="row">
                                    <th class="sorting_asc">ID</th>
                                    <th class="sorting">Datum</th>
                                    <th class="sorting">Status</th>
                                    <th class="sorting">Kunde</th>
                                    <th class="sorting">Produkt</th>
                                    <th class="sorting">Anzahl</th>
                                    <th class="sorting">Anfrage</th>
                                    <th class="sorting">Aktionen</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(inquiry, key) in inquiryArr">
                                    <td><a v-if="inquiry.client_id != 0" :href="'/kunde-' + inquiry.client_id" target="_blank" title="">{{ inquiry.id }}</a><span v-else>{{ inquiry.id }}</span><br /><button class="btn btn-metal btn-metal-mini">{{ inquiry.fromWebsite }}</button><br />
                                        <button v-if="inquiry.reminder" class="btn btn-warning btn-sm mt-2">REMINDER</button><br />
                                        <button v-if="inquiry.affiliate_id > 0" class="btn btn-danger btn-sm mt-2">Affiliate von: {{ inquiry.affiliate_id }}</button>
                                    </td>
                                    <td>{{ inquiry.eingang }}</td>
                                    <td>
                                        <span v-if="inquiry.status_id == 1 && inquiry.wait == 1" class="m-badge  m-badge--info m-badge--wide">wait</span>
                                        <span v-else-if="inquiry.status_id == 1" class="m-badge  m-badge--danger m-badge--wide">{{ inquiry.status }}</span>
                                        <span v-else-if="inquiry.status_id == 2" class="m-badge  m-badge--metal m-badge--wide">{{ inquiry.status }}</span>
                                        <span v-else-if="inquiry.status_id == 3" class="m-badge  m-badge--info m-badge--wide">{{ inquiry.status }}</span>
                                        <span v-else-if="inquiry.status_id == 4" class="m-badge  m-badge--danger m-badge--wide">{{ inquiry.status }}</span>
                                    </td>
                                    <td  width="250">
                                        <div class="m-card-user m-card-user--sm">
                                            <div class="m-card-user__pic">
                                                <div class="m-card-user__no-photo m--bg-fill-success" :class="'m-badge--client-class-' + inquiry.classId"><span>{{ inquiry.className }}</span></div>
                                            </div>
                                            <div class="m-card-user__details">
                                                <span class="m-card-user__name m--font-primary" v-if="inquiry.firma != ''" style="max-width:350px;">{{ inquiry.firma }}</span>
                                                <span class="m-card-user__name" style="max-width:350px;">{{ inquiry.name }}</span>
                                                <span class="m-card-user__name" style="max-width:350px;"><small><i class="fa fa-at"></i> {{ inquiry.email }}</small></span>
                                                <span class="m-card-user__name" v-if="inquiry.telefon != ''" style="white-space: nowrap"><small><i class="fa fa-phone"></i> {{ inquiry.telefon }}</small></span>
                                            </div>
                                        </div>
                                    </td>
                                    <td width="200">
                                        <table class="table-sm w-100">
                                            <tbody>
                                                <tr>
                                                    <td width="70">Kategorie:</td>
                                                    <td>{{ inquiry.categoryName }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Produkttyp:</td>
                                                    <td>{{ inquiry.produkttyp }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Produkte:</td>
                                                    <td>{{ inquiry.produkt }}</td>
                                                </tr>
                                                <tr>
                                                    <td>Preis:</td>
                                                    <td>{{ inquiry.price }} €</td>
                                                </tr>
                                                <tr>
                                                    <td>KW:</td>
                                                    <td>{{ inquiry.kw }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td nowrap>
                                        <span v-if="inquiry.approxmate_amout < 2" class="m-badge  m-badge--danger m-badge--wide">{{ inquiry.anzahlCa }}</span>
                                        <span v-else-if="inquiry.approxmate_amout > 5" class="m-badge  m-badge--success m-badge--wide">{{ inquiry.anzahlCa }}</span>
                                        <span v-else class="m-badge  m-badge--info m-badge--wide">{{ inquiry.anzahlCa }} Bilder</span>
                                        <div class="mt-2"><span class="m-badge  m-badge--brand m-badge--wide">{{ inquiry.sum }}</span></div>

                                    </td>
                                    <td v-html="inquiry.anfrage" style="max-width: 550px"></td>
                                    <td>
                                        <div class="mb-2"><a :href="'/anfrage-' + inquiry.id" class="btn btn-primary">Zur Anfrage</a></div>
                                        <div class="mb-2"><a target="_blank" :href="'https://app-eu1.hubspot.com/contacts/25794910/deal/' + inquiry.hubspot_id" class="btn btn-hubspot">Zu Hubspot</a></div>
                                        <div class="mb-2" v-if="inquiry.status_id == 1"><a crm-framework="inquiry-send" :inquiry-id="inquiry.id" class="m-badge  m-badge--success m-badge--wide" href="#" style="white-space: nowrap"><i class="la la-edit"></i> Anfrage gesendet</a></div>
                                        <div class="mb-2" v-if="inquiry.status_id == 1 && inquiry.wait == 0"><button :inquiry-id="inquiry.id" class="m-badge  m-badge--metal m-badge--wide inquiry-set-wait">Wait</button></div>
                                        <div class="mb-2" v-if="inquiry.status_id == 2"><button crm-framework="open-new-client" :inquiry-id="inquiry.id" class="m-badge  m-badge--primary m-badge--wide">Kunde anlegen</button></div>
                                        <div class="mb-2"><button :data-reminderid="inquiry.id" class="m-badge  m-badge--danger m-badge--wide reminder_close">Absage</button></div>
                                        <div class="mb-2" v-if="inquiry.status_id == 2"><button :inquiry-id="inquiry.id" class="m-badge  m-badge--warning m-badge--wide change_kw" crm-framework="change-kw">KW ändern</button></div>
                                        <div class="mb-2"><a href="#" @click="showDetails(inquiry)" class="m-badge  m-badge--info m-badge--wide">Updates ({{ inquiry.updates.length }})</a></div>
                                        <div class="mb-2" v-if="!newClients"><a :href="'/inquiry-client-is-new-' + inquiry.id" class="m-badge  m-badge--warning m-badge--wide reminder_update">Ist Neukunde</a></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <offer-details :detail-offer="detailOffer" :user="user" :reminder-type-arr="reminderTypeArr" :managers="managers"></offer-details>
    </div>
</template>
<script>
    import OfferDetails from "./offer/OfferDetails";

    export default {
        name: 'inquiry-site',

        components: {
            OfferDetails
        },
        props: {
            newClients: Boolean,
            user: Object,
            reminderTypeArr: Array,
            managers: Array,
        },

        data() {
            return {
                "inquiryArr": [],
                "showAClient": true,
                "showBClient": true,
                "showCClient": true,
                "showDClient": true,
                "showEClient": true,
                "showFClient": true,
                "status1": true,
                "status2": true,
                "status3": true,
                "wait": true,
                "reminder": true,
                "noreminder": false,
                "packageOnWay": false,
                "searchString": "",
                "inquiryType": 0,
                "detailOffer": null,
            }
        },

        mounted() {

            if (localStorage.showAClient) {
                this.showAClient = (localStorage.showAClient === 'true');
            }
            if (localStorage.showBClient) {
                this.showBClient = (localStorage.showBClient === 'true');
            }
            if (localStorage.showCClient) {
                this.showCClient = (localStorage.showCClient === 'true');
            }
            if (localStorage.showDClient) {
                this.showDClient = (localStorage.showDClient === 'true');
            }
            if (localStorage.showEClient) {
                this.showEClient = (localStorage.showEClient === 'true');
            }
            if (localStorage.showFClient) {
                this.showFClient = (localStorage.showFClient === 'true');
            }
            if (localStorage.status1) {
                this.status1 = (localStorage.status1 === 'true');
            }
            if (localStorage.status2) {
                this.status2 = (localStorage.status2 === 'true');
            }
            if (localStorage.status3) {
                this.status3 = (localStorage.status3 === 'true');
            }
            if (localStorage.wait) {
                this.wait = (localStorage.wait === 'true');
            }
            if (localStorage.reminder) {
                this.reminder = (localStorage.reminder === 'true');
            }
            if (localStorage.noreminder) {
                this.noreminder = (localStorage.noreminder === 'true');
            }
            if (localStorage.packageOnWay) {
                this.packageOnWay = (localStorage.packageOnWay === 'true');
            }
            if (localStorage.searchString) {
                this.searchString = JSON.parse(localStorage.searchString);
            }
            if (localStorage.inquiryType) {
                this.inquiryType = JSON.parse(localStorage.inquiryType);
            }

            this.loadData();
        },
        watch: {
            showAClient(val){
                localStorage.showAClient = val;
            },
            showBClient(val){
                localStorage.showBClient = val;
            },
            showCClient(val){
                localStorage.showCClient = val;
            },
            showDClient(val){
                localStorage.showDClient = val;
            },
            showEClient(val){
                localStorage.showEClient = val;
            },
            showFClient(val){
                localStorage.showFClient = val;
            },
            status1(val){
                localStorage.status1 = val;
            },
            status2(val){
                localStorage.status2 = val;
            },
            status3(val){
                localStorage.status3 = val;
            },
            wait(val){
                localStorage.wait = val;
            },
            reminder(val){
                localStorage.reminder = val;
            },
            noreminder(val){
                localStorage.noreminder = val;
            },
            packageOnWay(val){
                localStorage.packageOnWay = val;
            },
            searchString(val){
                localStorage.searchString =  JSON.stringify(val);
            },
            inquiryType(val){
                localStorage.inquiryType = parseInt(val);
            },
        },
        methods: {

            showDetails(offer) {
                this.detailOffer = offer;
            },
            loadData(){
                let ajaxUrl = "/ajax-inquiry";

                if (this.newClients){
                    ajaxUrl = "/ajax-new-inquiry";
                }

                $.ajax({
                    url : ajaxUrl,
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: { filterArr: this.filterArr },
                    success:  (data) => {
                        //console.log(data);

                        this.inquiryArr = [];
                        var temp = this;
                        var dataArr = JSON.parse(data);
                        dataArr.forEach(function(item) {

                            if (temp.inquiryArr.length < 100 &&
                                (temp.status1 && item.status_id == 1)  || (temp.status2 && item.status_id == 2) || (temp.status3 && item.status_id == 3) || (temp.wait && item.wait == 1 && item.status_id == 1) || (temp.reminder && item.reminder)
                            ){
                                if ((temp.showAClient && item.class_id == 1) || (temp.showBClient && item.class_id == 2) || (temp.showCClient && item.class_id == 3) || (temp.showDClient && item.class_id == 4) || (temp.showEClient && item.class_id == 5) || (temp.showFClient && item.class_id == 6) || item.class_id == 0){

                                    if ((temp.inquiryType == 0) || (temp.inquiryType == 1 && item.from_id == 0) || (temp.inquiryType == 2 && item.from_id == 1) || (temp.inquiryType == 3 && item.from_id == 2) || (temp.inquiryType == 4 && item.from_id == 3)){

                                        if (temp.searchString.length < 2 || (item.id == temp.searchString.toLowerCase() || item.firma.toLowerCase().indexOf(temp.searchString.toLowerCase()) != -1 || item.name.toLowerCase().indexOf(temp.searchString.toLowerCase()) != -1 || item.email.toLowerCase().indexOf(temp.searchString.toLowerCase()) != -1 || item.telefon.toLowerCase().indexOf(temp.searchString.toLowerCase()) != -1)){

                                            if (temp.noreminder === false || item.updates == 0){
                                                if (temp.packageOnWay === false || item.packageonway == 1) {
                                                    temp.inquiryArr.push(item);
                                                }
                                            }
                                        }

                                    }
                                }
                            }
                        });


                    },
                    error: function (jXHR, textStatus, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            }
        }
    }
</script>
